import { filename } from "./filename"

export const downloadVideo = async (cachedBlob) => {
  try {
    // const videoUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`
    // const response = await fetch(videoUrl)
    // const blob = await response.blob()

    const blobUrl = window.URL.createObjectURL(cachedBlob)
    const anchor = document.createElement("a")
    anchor.href = blobUrl
    anchor.download = filename()
    anchor.style.display = "none"

    document.body.appendChild(anchor)
    anchor.click()

    // Cleanup
    document.body.removeChild(anchor)
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error("Error downloading video:", error)
  }
}
